import { render, staticRenderFns } from "./ReviewYourAnswersEnfrc.vue?vue&type=template&id=42b86faa"
import script from "./ReviewYourAnswersEnfrc.vue?vue&type=script&lang=ts"
export * from "./ReviewYourAnswersEnfrc.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports